// -- Imports -- //
require('onbrandutilityfunctions/build/conditional-babel-polyfill.bundle.js'); // use all the things!
require('./onbrand.scss'); // Onbrand styles
require('./client/client.scss'); // client styles
const onbrandUtilityFunctions = require('onbrandutilityfunctions');
const devOptions = require('./dev-options.js'); // Development options
const updateTileLabels = require('./custom-modules/tileLabels');
const dateFromat = require('./custom-modules/dateFormat');
const webinars = require('./script-partials/upcomingWebinar');
const {
    addClassOnCtaGatedItem,
    replaceSearchOnMobile,
    homepageFulltile,
    homeSettings,
    handleSideCTATopAlignment,
} = require('./script-partials/homeSetting');
const item = require('./script-partials/itemlevelSettings');
const { ctaDesign } = require('./script-partials/ctaDesign');
const {
    calendarCTA,
    moveEmbeddedItem,
    newRelatedArrows,
    moveFlipbookTitle,
    firstLetterStyles,
    buildSidebar,
    openInNewWindow,
    salesStreamAvatarToggle,
    title,
    headerManage,
} = require('./script-partials/calenderCTA');
const { moveVideo } = require('./script-partials/moveVideo');
const { currentYear } = require('./script-partials/currentYear');
const { handleFilterInit } = require('./script-partials/filter/handleFiltering');
// -- Startup -- //
window.onbrandLoaded = false;

// old time embed error throw "fix" (TODO: make this better)
onbrandUtilityFunctions.legacyEmbedTileFix();
// Remove the "touch" class on touchscreen laptops
onbrandUtilityFunctions.removeTouchForLaptops();
// Remove the hub function updateOverlaySize
onbrandUtilityFunctions.overrideHubFuctions();
// Adds body classes for content type (blogPost, youtube, sales-stream etc)
onbrandUtilityFunctions.helpfulClasses();
// Rebuild the share widget for the top-nav
onbrandUtilityFunctions.fixShareWidgetImproved();
// warns you if your query string is missing.
onbrandUtilityFunctions.noQueryStringSafeguard();
// makes the reco engine sticky to the target / top of screen
onbrandUtilityFunctions.recoEnginePositioning('.top-nav');
// Pre hub event hub events (Note: disabled by default)
// onbrandUtilityFunctions.legacyEvents();

// -- Hub Events -- //
const onLoadAndPageChange = function() {
    onbrandUtilityFunctions.blockCtaFix();
    onbrandUtilityFunctions.fadeOutItem();
    moveEmbeddedItem('wistiar');
    updateTileLabels(window.tagLabels);
    openInNewWindow('3314489');
    dateFromat('data-source-stream-id="3314489"');
};

Hubs.Events.on('load', () => {
        if (!window.onbrandLoaded) {
            currentYear();
            item.sectionThreeColumn();
            title();
            // Add your onloads here...
            if (document.querySelector('body').classList.contains('hub-page')) {
                //Home page
                homeSettings();
                homepageFulltile();
            } else if (document.querySelector('body').classList.contains('single-page')) {
                //Item Level

                item.sliderlTitle();
                item.changePlacement();
                item.customerStories();
                item.removeLogo();
            } else if (document.querySelector('body').classList.contains('listing-page')) {
                //Stream level
                webinars.replaceAsFeaturedTile();
                webinars.webinars();
                webinars.streambanners();
                webinars.newIcon();
            }
            ctaDesign(); //OB-6175 cta design
            headerManage();
            newRelatedArrows();
            buildSidebar();
            replaceSearchOnMobile();
            addClassOnCtaGatedItem();
            firstLetterStyles();
            moveFlipbookTitle();
            calendarCTA();
            salesStreamAvatarToggle();
            onLoadAndPageChange();
            moveVideo();
            webinars.handleHighlightTile();
            handleFilterInit();

            // end your onloads before here...
            window.onbrandLoaded = true;
        }
    })
    .on('pageChange', () => {
        onLoadAndPageChange();
    })
    .on('itemsLoaded', (itemIds, selectors) => {
        ctaDesign(); //OB-6175 cta design
        homepageFulltile();
        updateTileLabels(window.obTagLabels);
        dateFromat('data-source-stream-id="3314489"');
        calendarCTA();
    }) //eslint-disable-line no-unused-vars
    .on('resize', () => {
        title();
        if (document.querySelector('body').classList.contains('hub-page')) {
            //Home page
            homeSettings();
        } else if (document.querySelector('body').classList.contains('listing-page')) {
            //Stream level
            webinars.streambanners();
        } else if (document.querySelector('body').classList.contains('single-page')) {
            //Item Level
            item.removeLogo();
        }
        headerManage();
        onbrandUtilityFunctions.sideCtaFix();
        onbrandUtilityFunctions.addThisFix();
    })
    .on('scroll', () => {
        onbrandUtilityFunctions.sideCtaFix();
        onbrandUtilityFunctions.addThisFix();
        onbrandUtilityFunctions.blockCtaFix();
        onbrandUtilityFunctions.fadeOutItem();
        handleSideCTATopAlignment();
    })
    .on('ctaActivate', (ctaId) => {}) //eslint-disable-line no-unused-vars
    .on('ctaFormSubmitSuccess', (ctaId, mappedData, ctaName) => {}) //eslint-disable-line no-unused-vars
    .on('search', () => {});

// The new hub events can trigger before cihost scripts are loaded.
// This will ensure your scripts fire no matter what, but not more than once for 'load'.
if (!window.onbrandLoaded) {
    Hubs.Events.trigger('load');
}


// WEBPACK FOOTER //
// ./onbrand.js